module.exports = __webpack_public_path__ + "img/terroir-moonlit-1.d26d4718.jpg";